import { render, staticRenderFns } from "./SnackMsj.vue?vue&type=template&id=a1b794ea&"
import script from "./SnackMsj.vue?vue&type=script&lang=js&"
export * from "./SnackMsj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports